import assign from 'object-assign';
import Cookies from '../common/utils/js-cookie/Cookies';
import webAppConfig from '../config';
import { httpLog } from '../common/utils/logging';
/* eslint no-param-reassign: 0 */


const defaults = {
  dataType: 'json',
  baseUrl: webAppConfig.WE_VOTE_SERVER_API_ROOT_URL,
  baseCdnUrl: webAppConfig.WE_VOTE_SERVER_API_CDN_ROOT_URL,
  url: webAppConfig.WE_VOTE_SERVER_API_ROOT_URL,
  query: {},
  method: 'GET',
  data () {
    return Cookies.get('voter_device_id') ? {
      // csrfmiddlewaretoken: Cookies.get('csrftoken'),
      voter_device_id: Cookies.get('voter_device_id'),
    } : {};
  },

  success: (res) => console.warn('Success function not defined:', res),
  error: (err) => console.error(`Ajax error: ${err.message}`),
};

/*
 * 2018: This function uses jQuery, to do deferred fetches from endpoints
 * React fetch is a more up to date way of doing this:
 *    https://facebook.github.io/react-native/docs/network.html
 *
 * 2016: The idea of this APIS.js file is to abstract away the details
 * of many repetitive service calls that we will be using.
 * @author Nick Fiorini <nf071590@gmail.com>
 */

export default function $ajax (options) {
  if (!options.endpoint) throw new Error('$ajax missing endpoint option');
  if (!defaults.baseCdnUrl) throw new Error('$ajax missing base CDN url option');
  if (!defaults.baseUrl) throw new Error('$ajax missing base url option');

  options.crossDomain = true;
  options.success = options.success || defaults.success;
  options.error = options.error || defaults.error;
  // console.log('service.js, options.endpoint: ', options.endpoint);
  if (options.endpoint === 'campaignStartSave' ||
      options.endpoint === 'organizationPhotosSave' ||
      options.endpoint === 'superShareItemSave' ||
      options.endpoint === 'voterContactListSave' ||
      options.endpoint === 'voterUpdate') {
    options.method = 'POST';
    // const csrftoken = Cookies.get('csrftoken');
    // const headers = new Headers();
    // headers.append('X-CSRFToken', csrftoken);
    // headers.append('Access-Control-Allow-Headers', 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers');
    // headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
    // headers.append('Access-Control-Allow-Origin', '*');
    // options.headers = headers;
  } else {
    options.method = 'GET';
  }
  // Switch between master API server and CDN
  if (options.endpoint === 'candidateRetrieve' ||
      options.endpoint === 'candidatesRetrieve' ||
      options.endpoint === 'defaultPricing' ||
      options.endpoint === 'measureRetrieve' ||
      options.endpoint === 'officeRetrieve'
  ) {
    // Retrieve API data from CDN
    options.data = assign({}, options.data || {}); // Do not pass voter_device_id
    options.url = `${defaults.baseCdnUrl}${options.endpoint}/`;
  } else {
    // Retrieve API from API Server Pool
    options.data = assign({}, options.data || {}, defaults.data());
    options.url = `${defaults.baseUrl}${options.endpoint}/`;
  }

  httpLog(`AJAX URL: ${options.url}`);
  if (options.endpoint === 'voterRetrieve') {
    httpLog('AJAX voter_device_id: ', Cookies.get('voter_device_id'));
  }

  /* eslint no-undef: ["error", { "typeof": true }] */
  // Attempts to wait until jQuery has loaded
  // window.onload = function() {
  //   if (window.jQuery) {
  //     return $.ajax(options);
  //   }
  //   console.log('Could not call options.endpoint:', options.endpoint);
  //   return null;
  // };
  // window.onload = function() {
  //   let a = setInterval( function() {
  //     if ( typeof window.jQuery === 'undefined' ) {
  //       return;
  //     }
  //     clearInterval(a);
  //
  //     console.log('jQuery is loaded'); // call your function with jQuery instead of this
  //     return $.ajax(options);
  //   }, 50);
  // };
  const { $ } = window;
  return $.ajax(options);
}
